/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSelector, shallowEqual, useDispatch } from 'react-redux'

import RenderError from '../../utils/RenderError';

import { Modal } from "react-bootstrap";
import { useFormik } from 'formik';

import {
  requestCreateRequestSupport,
} from "../../services/helpcenter";

const RequestSupport = ({isOpen, onClosed, originId, originType, isLoading}) => {
  const { helpCenter } = useSelector((state : any) => ({
    helpCenter: state.helpCenter,
  }), shallowEqual);

  const dispatch = useDispatch();

  const formik = useFormik<any>({
    initialValues: {
      message: '',
    },
    onSubmit: (values) => {
      dispatch<any>(requestCreateRequestSupport(originId, originType, values.message)).then(() => {
        formik.resetForm();

        onClosed();
      }).catch((error: any) => {
        //
      });
    },
  });

  return (
    <>
      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={isOpen}
        onHide={() => onClosed()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
          <Modal.Header>
            <Modal.Title id="cancel-schedule-title">
              <h2>
                <span className="text-white">Fale com o suporte</span>
              </h2>
            </Modal.Title>

            <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => onClosed()}>
              <span className="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="mx-auto min-w-320px mw-500px w-100 pt-0 mb-5 px-md-10">
              <div className="justify-content-center">
                <div className="justify-content-space-between d-flex mb-10">
                  <span className="flex-root text-center fs-4 text-white fw-bold">
                    Entraremos em contato o mais breve possível via e-mail ou WhatsApp
                  </span>
                </div>
                <div className="w-100 mb-5 text-center align-items-center justify-content-center">
                  <form
                    className="mx-auto mw-450px w-100 pt-0 pb-10"
                    id="request-support-form"
                    onSubmit={formik.handleSubmit}
                  >
                    <textarea
                      className="form-control"
                      placeholder="Descreva sua ocorrência"
                      {...formik.getFieldProps('message')}
                    />
                    {helpCenter?.error?.['message'] && <RenderError error={helpCenter.error['message']} />}

                    <button
                      type='submit'
                      className="btn btn-primary fw-bold flex-shrink-0 w-100 mt-3"
                      disabled={helpCenter.actionsLoading}
                    >
                      {!helpCenter.actionsLoading && <>
                        ENVIAR
                      </>}
                      {helpCenter.actionsLoading && <span className="indicator-label">
                        Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>}
                    </button>
                  </form>
                </div>

                {helpCenter.error && (typeof helpCenter.error) == "string" && <div className='d-flex mt-5 justify-content-center'>
                  <div className='fv-row'>
                    <div className="alert bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10">
                      <div className="d-flex flex-column text-primary pe-0 pe-sm-10">
                        <h5 className="mb-1">Erro na solicitação</h5>
                        <span>{helpCenter.error}</span>
                      </div>
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          </Modal.Body>
      </Modal>
    </>
  )
}

export {
  RequestSupport
}
